import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import moment from "moment";
import FileDownload from "react-file-download";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Title, Bold } from "../Styles";
import { ProfileService, JobService } from "../../lib/qc-api-client";
import {
  getApplicants as getApplicantsAction,
  getJob as getJobAction,
} from "../../redux/middleware/job";

import { DocumentViewer } from "../Shared";
import Utils from "../../lib/utils";
import Flash from "../Shared/Flash";
import {
  getProfile as getProfileAction,
  removeProfile as removeProfileAction,
} from "../../redux/middleware/profile";
import {
  getProfile,
  getProfilesError,
  getProfilesPending,
} from "../../redux/reducers/profile";
import Loader from "../Shared/Loader";
import {
  Button,
  MainContent,
  Header,
  HeaderTitle,
  HeaderDetails,
  UserName,
  MainSection,
  DownloadLink,
  Container,
  ProfileDetails,
  Sections,
} from "./Styles/Profile.styles";

const WorkExperienceSection = ({ profile }) => (
  <Sections>
    <Title>Work Experience</Title>
    <Row>
      <Col lg={12}>
        {profile.work_experiences &&
          profile.work_experiences.map((exp, i) => (
            <Row key={i}>
              <Col lg={3}>{exp.title}</Col>
              <Col lg={3}>{exp.company}</Col>
              <Col lg={3}>{moment(exp.start_date).format("MM/DD/YYYY")}</Col>
              <Col lg={3}>
                {exp.end_date && moment(exp.end_date).format("MM/DD/YYYY")}
              </Col>
            </Row>
          ))}
      </Col>
    </Row>
  </Sections>
);

const EducationSection = ({ profile }) => (
  <Sections>
    <Title>Education</Title>
    <Row>
      <Col lg={12}>
        {profile.educations &&
          profile.educations.map((education, i) => (
            <Row key={i}>
              <Col xs={3}>{Utils.uppercase(education.education_type)}</Col>
              <Col xs={3}>{education.institution}</Col>
              <Col xs={3}>{education.city_state}</Col>
              <Col xs={3}>{education.country}</Col>
            </Row>
          ))}
      </Col>
    </Row>
  </Sections>
);

const SkillsSection = ({ profile }) => (
  <Sections>
    <Title>Skills</Title>
    <Row>
      <Col lg={12}>
        {profile.skill_sets &&
          profile.skill_sets.map((skill_set, i) => (
            <Row key={i}>
              <Col xs={3}>{skill_set.skill}</Col>
              <Col xs={3}>{skill_set.years_experience} Years</Col>
              <Col xs={3}>{skill_set.last_used}</Col>
            </Row>
          ))}
      </Col>
    </Row>
  </Sections>
);

class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {},
      profile: {},
      lastUpdated: '',
      profile_data: {},
      job_status: "",
      messages: [],
      pending: true,
    };
  }

  componentWillMount() {
    const { id, match, getApplicants, ownerId, getProfile } = this.props;
    const { jobId } = match.params;
    getApplicants({ id: jobId, owner_id: ownerId });
    getProfile(id);
  }

  componentWillReceiveProps = (nextProps) => {
    this.setState({ messages: [] });
    window.scrollTo(0, 0);
    nextProps.applicants &&
      nextProps.profile &&
      this.setState((prevState) => ({
        ...prevState,
        user: nextProps.applicants.find(
          (applicant) =>
            applicant.application.profile_id === nextProps.profile.id
        ).user,
        pending: false,
      }));
  };

  downloadResume = (url, fileName) => {
    ProfileService.downloadResume(url)
      .then(response => {
        FileDownload(response.data, fileName);
      })
      .catch(error => console.error(error.message))
  }

  flashMessage = (message, status) => {
    this.setState({messages: [{message: message, status: status}]});
    setTimeout(this.setState({flash: null}), 2000)
  }

  saveApplicant = () => {
    let { id, job, profile } = this.props;

    JobService.saveApplicant(job, id, profile.id)
      .then(response => {

        this.setState({
          job_status: 'saved'
        })
        this.flashMessage('Applicant Saved', 'success');
      })
      .catch(error => {
        this.flashMessage('Something Went wrong. Please try again.', 'danger');
      })
  }

  rejectApplicant = () => {
    let { id, job, profile } = this.props;

    JobService.rejectApplicant(job.id, id, profile)
      .then(response => {

        this.setState({
          job_status: 'rejected'
        })
        this.flashMessage('Applicant Rejected', 'success');
      })
      .catch(error => {
        this.flashMessage('Something Went wrong. Please try again.', 'danger');
      })
  }

  hide = () => {
    this.setState({show_document_viewer: false})
  }

  render() {
    const { job_status, messages, user, pending } = this.state;
    if (pending) return <Loader fullScreen vwidth="50%" show />;

    const { profile, employmentTypes } = this.props;
    const lastUpdated = moment(profile.updated_at).format("MM/DD/YYYY");
    const fullName = `${user.fname} ${user.lname}'s Resume`;
    const viewResume = (content) => {
       this.setState({ show_document_viewer: true, content })
    }

    return (
      <Container className="TabbedPanelsContent TabbedPanelsContentVisible">
        {messages.length > 0 && <Flash messages={messages} />}
        <Header>
          <div>
            <HeaderTitle className="pull-left">Applicant Profile</HeaderTitle>
            <div className="pull-right">
              {job_status === "pending" && (
                <div>
                  <Button
                    className="hidden-xs hidden-md"
                    onClick={this.saveApplicant}
                  >
                    Save
                  </Button>
                  <Button
                    className="hidden-xs hidden-md"
                    onClick={this.rejectApplicant}
                  >
                    Reject
                  </Button>
                </div>
              )}
              {job_status === "saved" && (
                <Button
                  className="hidden-xs hidden-md"
                  onClick={this.rejectApplicant}
                >
                  Reject
                </Button>
              )}
              {job_status === "rejected" && (
                <Button
                  className="hidden-xs hidden-md"
                  onClick={this.saveApplicant}
                >
                  Save
                </Button>
              )}
            </div>
          </div>
          <div style={{ clear: "both" }}>
            <HeaderDetails>Last Updated: {lastUpdated}</HeaderDetails>
          </div>
        </Header>

        <MainContent>
          <MainSection>
            <Row>
              <Col md={6}>
                <UserName>
                  {user.fname} {user.lname}
                </UserName>
              </Col>
              <Col md={6}></Col>
            </Row>
          </MainSection>

          <ProfileDetails>
            <Row>
              <Col md={12} xsHidden>
                <ul>
                  {user && user.phone_primary && (
                    <li>
                      <label>
                        <i className="fa fa-phone" />
                        {user.phone_primary}
                      </label>
                    </li>
                  )}
                  {user && user.email && (
                    <li>
                      <label>
                        <i className="fa fa-envelope-o" /> {user.email}
                      </label>
                    </li>
                  )}
                  {((user && user.city) || (user && user.state)) && (
                    <li>
                      <label>
                        <i className="fa fa-location-arrow" />
                        {user.city}, {user.state} {user.zip}
                      </label>
                    </li>
                  )}
                </ul>
              </Col>
            </Row>
            <Row>
              <Col xs={1} smHidden mdHidden lgHidden>
                <Bold>
                  <i className="fa fa-phone" />
                </Bold>
              </Col>
              <Col xs={11} smHidden mdHidden lgHidden>
                <Bold>{user && user.phone_primary}</Bold>
              </Col>
            </Row>
            <Row>
              <Col xs={1} smHidden mdHidden lgHidden>
                <Bold>
                  <i className="fa fa-envelope-o" />
                </Bold>
              </Col>
              <Col xs={11} smHidden mdHidden lgHidden>
                <Bold>{user && user.email}</Bold>
              </Col>
            </Row>
            <Row>
              <Col xs={1} smHidden mdHidden lgHidden>
                <Bold>
                  <i className="fa fa-location-arrow" />
                </Bold>
              </Col>
              <Col xs={11} smHidden mdHidden lgHidden>
                <Bold>
                  {user && user.city}, {user && user.state} {user && user.zip}
                </Bold>
              </Col>
            </Row>
          </ProfileDetails>

          <Sections>
            <Title>{profile.title}</Title>
            <Row className="profile_detail post">
              <Col lg={2}>
                <label>{employmentTypes && employmentTypes.join(", ")}</label>
              </Col>
            </Row>
            <Row>
              <Col md={3} xs={6}>
                <Bold>US Citizen?</Bold>
              </Col>
              <Col md={3} xs={6}>
                {profile && profile.us_citizen ? "Yes" : "No"}
              </Col>
              <Col md={3} xs={6}>
                <Bold>Relocate?</Bold>
              </Col>
              <Col md={3} xs={6}>
                {profile && profile.relocate ? "Yes" : "No"}
              </Col>
            </Row>
            <Row>
              <Col md={3} xs={6}>
                <Bold>Security Clearance?</Bold>
              </Col>
              <Col md={3} xs={6}>
                {profile && profile.security_clearance ? "Yes" : "No"}
              </Col>
              <Col md={3} xs={6}>
                <Bold>Military Veteran?</Bold>
              </Col>
              <Col md={3} xs={6}>
                {profile && profile.veteran ? "Yes" : "No"}
              </Col>
            </Row>
            <Row>
              <Col md={3} xs={6}>
                <Bold>Annual Salary:</Bold>
              </Col>
              <Col md={3} xs={6}>
                {profile && Utils.currencyFormatter(profile.salary)}
              </Col>
              <Col md={3} xs={6}>
                <Bold>Hourly Rate:</Bold>
              </Col>
              <Col md={3} xs={6}>
                {profile && Utils.currencyFormatter(profile.hourly_rate, 2)}
              </Col>
            </Row>
            <Row>
              <Col md={3} xs={6}>
                <Bold>Resume:</Bold>
              </Col>
              <Col md={3} xs={6}>
                {profile.resume ? (
                  <div onClick={viewResume(profile.resume.content)}>
                    <DownloadLink>View Resume</DownloadLink>
                  </div>
                ) : (
                  <div className="input">
                    <div>No resume at this time.</div>
                  </div>
                )}
              </Col>
            </Row>
          </Sections>

          <SkillsSection profile={profile} />
          <WorkExperienceSection profile={profile} />
          <EducationSection profile={profile} />

          <DocumentViewer
            show={this.state.show_document_viewer}
            hide={this.hide}
            content={this.state.content}
            title={fullName}
          />
        </MainContent>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  error: getProfilesError(state),
  profile: getProfile(state),
  applicants: state.applicants.applicants,
  applicantsPending: state.applicants.pending,
  pending: getProfilesPending(state),
  ownerId: state.userByToken.user?.id,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getProfile: getProfileAction,
      removeProfile: removeProfileAction,
      getApplicants: getApplicantsAction,
      getJob: getJobAction,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Profile));
